import { PlusOutlined } from '@ant-design/icons';
import { ServiceSelect } from '@components';
import { L } from '@lib';
import { Button, Col, Row, Typography } from 'antd';
import React from 'react';

const { Text } = Typography;

interface IProps {
  service?: number | number[];
  cleanName?: boolean;
  required?: boolean;
  serviceTitle?: string;
  onSelect?: (value: number) => void;
  onAddClick?: React.MouseEventHandler<HTMLElement> | undefined;
  onClear?: () => void;
}

export const ServiceAddSelect: React.FC<IProps> = ({
  service,
  cleanName,
  serviceTitle = 'Service name',
  required = false,
  onSelect,
  onAddClick,
  onClear,
}) => {
  return (
    <div style={{ marginBottom: 16 }}>
      {serviceTitle && (
        <Text>
          <Text strong style={{ color: '#ff4d4f' }}>
            *
          </Text>{' '}
          {L(serviceTitle)}
        </Text>
      )}

      <Row align="middle" gutter={8} wrap={false}>
        <Col flex="auto">
          <ServiceSelect
            value={service}
            cleanName={cleanName}
            status={required ? 'error' : undefined}
            onSelect={onSelect}
            onClear={onClear}
          />
        </Col>
        <Col flex="none">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={onAddClick}
            style={{ background: '#52c41a', borderColor: '#52c41a', minWidth: 110 }}
          >
            {L('Add new')}
          </Button>
        </Col>
      </Row>

      {required && <Text style={{ color: 'red' }}>{L('Required')}</Text>}
    </div>
  );
};
